/**
 * Turns a user id into a name, from the analyst roster, for audit lines such as
 * "last changed by Alice". Falls back to the id itself while the roster loads,
 * for someone no longer on it, or for a roster entry with no name (an account
 * whose profile was never filled in), so the line never reads "by  on".
 */

import { useCallback } from 'react';

import { useAnalystRoster } from './useAnalystRoster';

export function useActorNames(): (userId: string) => string {
  const members = useAnalystRoster();
  return useCallback(
    (userId: string) => members.find((m) => String(m.id) === userId)?.name?.trim() || userId,
    [members]
  );
}
